import { render, staticRenderFns } from "./weekly-ads.vue?vue&type=template&id=e8da37b4&scoped=true&"
import script from "./weekly-ads.vue?vue&type=script&lang=js&"
export * from "./weekly-ads.vue?vue&type=script&lang=js&"
import style0 from "./weekly-ads.vue?vue&type=style&index=0&id=e8da37b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8da37b4",
  null
  
)

export default component.exports